export const FormState = {
  New: `new`,
  Existing: `existing`,
  Connecting: `connecting`,
}
